import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  ROLE_CREATE,
  PERMISSION_LIST
} from "../../routes/routes";
import Form from 'react-bootstrap/Form';
import { toast } from "react-toastify";
import { NoDataFound } from "../../components/Utils";
import Loader from '../../components/common/Loader'; // Import the loader component
import { ROLE_CREATED } from "../../constant/constant";
import { ValidationMessage } from "../../components/Utils";
import Select from "react-select";
import { ADMIN_ROLE_TYPE_OPTIONS } from "../Admin/adminTypeConfig";

const RoleCreate = () => {
  const navigate = useNavigate();
  const defaultFormData = {
    name: "",
    admin_type: null,
    permissions: []
  }
  const [form, setForm] = useState(defaultFormData);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [selectAllOption, setSelectAllOption] = useState(false);
  const [loading, setLoading] = useState(true);
  const [permissionOptions, setPermissionOptions] = useState({});
  const [errors, setErrors] = useState({});

  /**   *
   * @param {*} input
   * @param {*} callback
   */

  const submit = () => {
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .post(ROLE_CREATE, requestBody)
      .then((res) => {
        if (res.status === 201 && res.data.success) {
          toast.success(ROLE_CREATED);
          navigate("/roles");
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      }).finally(() => {
        setBtnDisabled(false);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch permission data
        const permissionResponse = await axios.get(PERMISSION_LIST)
          .finally(() => {
            setLoading(false);
          });
        const fetchedPermissionOptions = permissionResponse.data.data;
        setPermissionOptions(fetchedPermissionOptions);

        // Auto-select only main Dashboard view
        const dashboardViewPerm = [];
        if (fetchedPermissionOptions['Dashboard']) {
          Object.values(fetchedPermissionOptions['Dashboard']).forEach(typeArray => {
            if (Array.isArray(typeArray)) {
              typeArray.forEach(p => {
                if (p.name === 'dashboard-view') {
                  dashboardViewPerm.push(p.name);
                }
              });
            }
          });
        }
        if (dashboardViewPerm.length > 0) {
          setForm(prev => ({ ...prev, permissions: [...new Set([...prev.permissions, ...dashboardViewPerm])] }));
        }

      } catch (error) {
        console.error('Error while fetching permission data:', error);
      }
    }
    fetchData();
  }, [])

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Roles & Permissions</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li>
                  <Link to={"/roles"}>
                    <span>Roles & Permissions List</span>
                  </Link>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Create Roles & Permissions</span></li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/roles"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
 
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Create Role</h5> */}
              </div>
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="admin_type"
                        >
                          Admin Type<span className="text-danger">*</span>
                        </label>
                        <Select
                          placeholder="Select Admin Type"
                          options={ADMIN_ROLE_TYPE_OPTIONS}
                          value={
                            form?.admin_type
                              ? ADMIN_ROLE_TYPE_OPTIONS.find(
                                  (opt) => opt.value === Number(form.admin_type)
                                ) || null
                              : null
                          }
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              admin_type: selected ? selected.value : null,
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="admin_type" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="name"
                        >
                          Role Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Name"
                          onChange={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="name" />
                      </div>
                    </div>
 
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="membership_status"
                        >
                          Permission access<span className="text-danger">*</span>
                        </label>
                        <div className="table-responsive text-nowrap">
                          <table className="table itable table-bordered">
                            <thead>
                              <tr>
                                <th>Menu Name</th>
                                <th>Access name</th>
                                <th className="text-center">Add</th>
                                <th className="text-center">Edit</th>
                                <th className="text-center">View</th>
                                <th className="text-center">Delete</th>
                                <th className="text-center">Export</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <Loader loading={loading} colspan="7" />
                              ) :
                                Object.keys(permissionOptions).length > 0 ? (
                                  Object.keys(permissionOptions).map((menu, i) => {
                                    // Group permissions by base name (feature)
                                    const features = {};
                                    ['create', 'edit', 'list', 'delete', 'export'].forEach(type => {
                                      const perms = permissionOptions[menu][type];
                                      if (perms && Array.isArray(perms)) {
                                        perms.forEach(p => {
                                          const baseName = p.access_name || p.name.split('-')[0];
                                          if (!features[baseName]) features[baseName] = {};
                                          features[baseName][type] = p;
                                        });
                                      }
                                    });
 
                                    const featureKeys = Object.keys(features);
                                    return featureKeys.map((featureName, index) => {
                                      const featurePerms = features[featureName];
 
                                      const toggleSingle = (name, checked, isNonViewAction) => {
                                        if (name === 'dashboard-view' && !checked) return;

                                        let updatedPermissions = [...form.permissions];
                                        if (checked) {
                                          updatedPermissions.push(name);
                                          // Auto-select view if non-view action is selected
                                          if (isNonViewAction && featurePerms.list && !updatedPermissions.includes(featurePerms.list.name)) {
                                            updatedPermissions.push(featurePerms.list.name);
                                          }
                                        } else {
                                          updatedPermissions = updatedPermissions.filter(p => p !== name);
                                        }
                                        setForm({ ...form, permissions: [...new Set(updatedPermissions)] });
                                      };

                                      const isViewDisabled = (featurePerms) => {
                                        if (featurePerms.list?.name === 'dashboard-view') return true;
                                        return (
                                          (featurePerms.create && form.permissions.includes(featurePerms.create.name)) ||
                                          (featurePerms.edit && form.permissions.includes(featurePerms.edit.name)) ||
                                          (featurePerms.delete && form.permissions.includes(featurePerms.delete.name)) ||
                                          (featurePerms.export && form.permissions.includes(featurePerms.export.name))
                                        );
                                      };

                                      return (
                                        <tr key={`${menu}-${featureName}`} className={i % 2 === 0 ? 'table-tr-light' : 'table-tr-dark'}>
                                          {index === 0 && (
                                            <td rowSpan={featureKeys.length} className="align-middle fw-bold bg-light">
                                              {menu}
                                            </td>
                                          )}
                                          <td>{featureName}</td>
                                          <td className="text-center">
                                            {featurePerms.create && (
                                              <Form.Check
                                                type="switch"
                                                checked={form.permissions.includes(featurePerms.create.name)}
                                                onChange={(e) => toggleSingle(featurePerms.create.name, e.target.checked, true)}
                                              />
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {featurePerms.edit && (
                                              <Form.Check
                                                type="switch"
                                                checked={form.permissions.includes(featurePerms.edit.name)}
                                                onChange={(e) => toggleSingle(featurePerms.edit.name, e.target.checked, true)}
                                              />
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {featurePerms.list && (
                                              <Form.Check
                                                type="switch"
                                                checked={form.permissions.includes(featurePerms.list.name)}
                                                onChange={(e) => toggleSingle(featurePerms.list.name, e.target.checked, false)}
                                                disabled={isViewDisabled(featurePerms)}
                                              />
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {featurePerms.delete && (
                                              <Form.Check
                                                type="switch"
                                                checked={form.permissions.includes(featurePerms.delete.name)}
                                                onChange={(e) => toggleSingle(featurePerms.delete.name, e.target.checked, true)}
                                              />
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {featurePerms.export && (
                                              <Form.Check
                                                type="switch"
                                                checked={form.permissions.includes(featurePerms.export.name)}
                                                onChange={(e) => toggleSingle(featurePerms.export.name, e.target.checked, true)}
                                              /> 
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    });
                                  })
                                ) : (
                                  <NoDataFound colspan="7" message="No Permissions Found" />
                                )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/roles"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleCreate;
